export const BUS_SHOW_IN_MENU = 'show-in-menu'